$(document).on('turbolinks:load', function () {
  if ($('.player-mgmt-list').length === 0) return;

  var csrfToken = $('meta[name="csrf-token"]').attr('content');

  function replaceToggle($wrapper, templateSelector, attributes) {
    var template = $wrapper.find(templateSelector).get(0);
    if (!template || !template.content) return;

    var container = template.content.querySelector('.hidden-player-toggle-container').cloneNode(true);
    var button = container.querySelector('button');
    Object.keys(attributes).forEach(function(key) {
      button.dataset[key] = attributes[key];
    });
    $wrapper.find('.hidden-player-toggle-container').remove();
    $wrapper.append(container);
  }

  // 非表示にする
  $('.played-players-list').on('click', '.action-link--muted', function () {
    var $btn = $(this);
    if ($btn.prop('disabled')) return;
    $btn.prop('disabled', true);
    var $wrapper = $btn.closest('.hidden-player-toggle-wrapper');
    var $card = $btn.closest('.player-mgmt-row');
    var playerId = $btn.data('player-id');

    $.ajax({
      url: '/players/hidden_players',
      method: 'POST',
      data: { hidden_player_id: playerId },
      headers: { 'X-CSRF-Token': csrfToken },
      dataType: 'json'
    }).done(function (data) {
      replaceToggle($wrapper, '.js-hidden-player-show-template', { id: data.id });
      $card.addClass('player-mgmt-row--hidden');
    }).fail(function (xhr) {
      $btn.prop('disabled', false);
      var msg = xhr.responseJSON && xhr.responseJSON.errors
        ? xhr.responseJSON.errors.join(', ')
        : $wrapper.data('operation-failed');
      alert(msg);
    });
  });

  // セクションの折りたたみトグル（対局済み / 未対局 共通）
  $('.player-mgmt-toggle').on('click', function () {
    var $list = $(this).siblings('.player-mgmt-list');
    var $closeText = $(this).find('.toggle-close');
    $list.slideToggle(300);
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
      $closeText.stop(true, true).slideDown(200);
    } else {
      $closeText.stop(true, true).slideUp(200);
    }
  });

  // 表示に戻す
  $('.played-players-list').on('click', '.action-link--show', function () {
    var $btn = $(this);
    if ($btn.prop('disabled')) return;
    $btn.prop('disabled', true);
    var $wrapper = $btn.closest('.hidden-player-toggle-wrapper');
    var $card = $btn.closest('.player-mgmt-row');
    var id = $btn.data('id');

    $.ajax({
      url: '/players/hidden_players/' + id,
      method: 'DELETE',
      headers: { 'X-CSRF-Token': csrfToken },
      dataType: 'json'
    }).done(function (data) {
      replaceToggle($wrapper, '.js-hidden-player-hide-template', { playerId: data.hidden_player_id });
      $card.removeClass('player-mgmt-row--hidden');
    }).fail(function () {
      $btn.prop('disabled', false);
      alert($wrapper.data('operation-failed'));
    });
  });
});
